import React, { useEffect } from 'react';
import './ErrorPopup.css';

const ErrorPopup = ({ message, onClose, type = 'error' }) => {
  useEffect(() => {
    // Dodaj class ko se popup prikaže
    document.body.classList.add('error-popup-active');
    
    // Odstrani class ko se komponenta unmonta
    return () => {
      document.body.classList.remove('error-popup-active');
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="error-popup-overlay">
      <div className={`error-popup ${type}`}>
        <div className="error-content">
          <div className="error-icon">
            {type === 'error' ? '❌' : '⚠️'}
          </div>
          <div className="error-message">
            <h3>Napaka pri komunikaciji</h3>
            <p>Opravičujemo se za nevšečnosti. Trenutno imamo težave s povezavo. Prosimo, poskusite znova čez nekaj trenutkov.</p>
          </div>
          <button className="error-refresh" onClick={handleRefresh}>
            Osveži stran
          </button>
        </div>
      </div>
    </div>
  ); 
};

export default ErrorPopup; 
